export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/grn-list`,
        name: `${prefix}.grn-list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.grn-list.index`,
                PageDescription: "Supplier Module: GRN",
            },
        },
    },
    {
        path: `/${prefix}/grn-list/create`,
        name: `${prefix}.grn-list.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.grn-list.index`,
                PageDescription: "Supplier Module: GRN",
            },
        },
    },
    {
        path: `/${prefix}/grn-list/print/:GRNNO`,
        name: `${prefix}.grn-list.print`,
        component: () => import('./Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.grn-list.index`,
                PageDescription: "Supplier Module: GRN",
            },
            print: true,
        },
    }, {
        path: `/${prefix}/grn-list/view/:GRNNO`,
        name: `${prefix}.grn-list.view`,
        component: () => import('./View.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.grn-list.index`,
                PageDescription: "Supplier Module: GRN",
            },
            print: true,
        },
    },
];